import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '@account-environments/environment';
import {Observable} from 'rxjs';
import {
  ApiAccountBackendUsersUpdateRequest,
  ApiAccountBackendUsersUpdateResponse
} from '@account/shared/api/account-backend-users';

@Injectable({
  providedIn: 'root'
})
export class AccountBackendUsersService {

  constructor(private http: HttpClient) { }

  update(data: ApiAccountBackendUsersUpdateRequest['params']['data']): Observable<ApiAccountBackendUsersUpdateResponse>{
    const body: ApiAccountBackendUsersUpdateRequest = {
      id: 'updateAccountBackendUser#INVALID_PARAMS',
      command: 'accountBackendUsers/update',
      params: {
        data
      }
    };
    return this.http.post<ApiAccountBackendUsersUpdateResponse>(environment.urlMainApi, JSON.stringify(body));
  }
}
